import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { posModalStyles as modalStyles } from "../modalPrimitives";
import { useViewport } from "../../../../hooks/useViewport";
import { R } from "../orderingTheme";
import {
  ModalHeader,
  ModalFooter,
  GhostButton,
  PrimaryButton,
} from "../modalPrimitives";

interface DiscardOrderModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DiscardOrderModal = ({
  open,
  onCancel,
  onConfirm,
}: DiscardOrderModalProps) => {
  const { t } = useTranslation();
  const { isMobile, isNarrow, isTablet } = useViewport();

  const width = isMobile ? undefined : isTablet ? 420 : 460;
  const bodyPad = isNarrow ? "16px" : "20px 24px";

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      closable={false}
      destroyOnHidden
      width={width}
      styles={modalStyles}
      style={{ maxWidth: "calc(100vw - 32px)" }}
    >
      <div style={{ background: R.surface, color: R.text }}>
        <ModalHeader
          icon={<ExclamationCircleOutlined />}
          title={t("ordering.discardItemsConfirmTitle")}
          onClose={onCancel}
          isNarrow={isNarrow}
        />

        <div style={{ padding: bodyPad }}>
          <p
            style={{
              margin: 0,
              fontSize: 13.5,
              fontWeight: 500,
              color: R.textSoft,
              lineHeight: 1.55,
            }}
          >
            {t("ordering.discardItemsConfirmContent")}
          </p>
        </div>

        <ModalFooter isNarrow={isNarrow}>
          <GhostButton label={t("common.no")} onClick={onCancel} />
          <PrimaryButton label={t("common.yes")} onClick={onConfirm} />
        </ModalFooter>
      </div>
    </Modal>
  );
};
